module.exports = __webpack_public_path__ + "img/vase_details_en-US.e1c9d690.svg";